import * as uuid from 'uuid';

/**
 * Stable, per-browser device identifier used for the videocall "Hybrid"
 * stabilization (Wire Contract v3).
 *
 * - Generated once and persisted in localStorage.
 * - Sent on every HTTP request as the `X-Device-Id` header (see
 *   session.interceptor.ts).
 * - Used locally to disambiguate which physical client a videocall
 *   answer/cancel/initiator belongs to.
 *
 * Backward-compat: this is purely additive. If the value is unavailable the
 * header is simply omitted and the API falls back to per-user behavior.
 */
const DEVICE_ID_KEY = 'device_id';

export function getDeviceId(): string | null {
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id = uuid.v4();
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    // localStorage may be unavailable (private mode, etc.). Fail open: the
    // header is omitted and the API keeps the current per-user behavior.
    return null;
  }
}
